import * as React from 'react';
import { FieldArray } from 'formik';
import { Input } from 'src/components/Shared/BsInput';
import InputErrorClass from 'src/components/Shared/InputErrorClass';
import { DestinationsAutocomplete } from 'lesamis-react-components';

export default class Destinations extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.renderSelected = this.renderSelected.bind(this);
  }

  public render() {
    const { values, handleChange, errors } = this.props;
    return (
      <div>
        <div className="form-group">
          <label>Formato</label>
          <select
            className={InputErrorClass({ errors, name: 'data.destinationsFormat' })}
            name="data.destinationsFormat"
            onChange={handleChange}
            value={values.data.destinationsFormat}
          >
            <option value=""></option>
            <option value="packages">Paquetes por destino</option>
            <option value="detail">Detalle</option>
            <option value="cards">Tarjetas</option>
            <option value="full">Completo</option>
            <option value="map">Mapa</option>
          </select>
          {errors['data.destinationsFormat'] && <p className="invalid-feedback">{errors['data.destinationsFormat']}</p>}
        </div>
        <FieldArray
          name="data.destinations"
          render={(arrayHelpers) => {
            return (
              <div>
                <div className="form-group">
                  <label>Destinos</label>
                  <DestinationsAutocomplete
                    settings={{
                      endpoint: 'autocompleteFull'
                    }}
                    onSelected={(selected: any) => {
                      if (!selected) {
                        return;
                      }

                      arrayHelpers.push({
                        type: selected.type,
                        order: values.data.destinations.length + 1,
                        id: selected.id,
                        name: selected.name,
                        slug: selected.slug || selected.name,
                        link: '',
                        country_id: selected.Country ? selected.Country.id : null,
                        country_slug: selected.Country ? selected.Country.slug : null,
                      });
                    }}
                    renderOption={(option: any, i: number) => {
                      if (option.type === 'CITY') {
                        return (<div key={i}>{option.name}, {option.Country.name}</div>);
                      }

                      return (<div key={i}>{option.name}</div>);
                    }}
                  />
                </div>
                {
                  values.data.destinations.map((d: any, i: number) =>
                    this.renderSelected(d, i, arrayHelpers)
                  )
                }
              </div>
            );
          }}
        />
      </div>
    )
  }

  private renderSelected(destination: any, index: number, arrayHelpers: any) {
    const { errors } = this.props;

    return (
      <div className="card mb-3" key={index}>
        <div className="card-body">
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <label>Tipo</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={destination.type}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>ID</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={destination.id}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Nombre</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={destination.name}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Slug</label>
                <input
                  type="text"
                  readOnly
                  className="form-control"
                  value={destination.slug}
                />
              </div>
            </div>
            <div className="col">
              <Input
                label="Orden"
                value={destination.order}
                name={`data.destinations.${index}.order`}
                onChange={this.props.handleChange}
                errors={errors}
                type="number"
              />
              <div className="form-group">
                <label>Link</label>
                <input
                  type="text"
                  name={`data.destinations.${index}.link`}
                  onChange={this.props.handleChange}
                  className="form-control"
                  value={destination.link}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="text-right">
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={(e) => {
                e.preventDefault();
                arrayHelpers.remove(index);
              }}
            >
              <i className="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>

    );
  };
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/Destinations.tsx